import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD1jRKCMats08Ylbv3BKxGeIZlAOT6qciE",
  authDomain: "studenthub-30c32.firebaseapp.com",
  projectId: "studenthub-30c32",
  storageBucket: "studenthub-30c32.firebasestorage.app",
  messagingSenderId: "64244036158",
  appId: "1:64244036158:web:74a7020e6155398641176f",
  measurementId: "G-LHTFXR395S"
};

const app = initializeApp(firebaseConfig);

// Rejects Firestore/Storage requests that don't come from this real web app
// (scripted abuse, scraped API keys) once Enforce mode is turned on for
// Firestore/Storage in the App Check console. Silently skipped when no site
// key is configured (e.g. before App Check is set up, or in local dev)
// rather than breaking the app. Enterprise, not classic v3 — that's the only
// reCAPTCHA option the App Check console offers for new app registrations now.
const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
if (typeof window !== 'undefined' && recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);

// Storage is only needed by the admin image-upload flow, so it's loaded
// lazily there instead of shipping firebase/storage in every page's bundle.
export function getBlogStorage() {
  return import('firebase/storage').then(({ getStorage }) => getStorage(app));
}
